import React, { useState, useCallback, useContext, useMemo } from 'react';
import { ConfirmationModal, TextArea } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const RequestDeclineReasonModal = ({ onClose, onSubmit, declineRequest, requestIds = [], isBulk = false }) => {
  const { t } = useContext(ConfigContext);

  const [managerReason, setManagerReason] = useState('');

  const onDecline = useCallback(async () => {
    if (!requestIds.length) return;

    await declineRequest({ managerReason, requestIds, isBulk });
    if (onSubmit) {
      onSubmit();
    } else {
      onClose();
    }
  }, [declineRequest, isBulk, managerReason, onClose, onSubmit, requestIds]);

  const textPlaceHolder = useMemo(
    () =>
      !isBulk
        ? t('declineReason')
        : requestIds.length === 1
        ? t('areYouSureDeclineXRequest', { amount: requestIds.length })
        : t('areYouSureDeclineXRequests', { amount: requestIds.length }),
    [requestIds, isBulk, t]
  );

  return (
    <ConfirmationModal
      onConfirm={onDecline}
      usePortal
      onClose={onClose}
      title={isBulk ? t('declineRequests') : t('explainDeclineReason')}
      disabledConfirm={!managerReason}
      confirmText={t('sendRejectionEmployee')}>
      <TextArea
        value={managerReason}
        onChange={setManagerReason}
        placeholder={textPlaceHolder}
        minRows={4}
        maxLength={1000}
      />
    </ConfirmationModal>
  );
};

export default RequestDeclineReasonModal;
